export default "__VITE_ASSET__eoVXKiyj__"